import {
  cloudinaryImage,
  getTotalPayoutImageTag,
} from '@monorepo/client-common';
import {
  Achievement,
  StorageContentType,
  USER_PUBLIC_ID,
} from '@monorepo/types';
import { BaseResponse } from '../core/base-entity-service';
import CrudService from '../core/crud-service';
import { EnvService } from '../core/env-service';

const { application, isProduction } = EnvService.get();

/**
 *
 */
export default class AchievementService extends CrudService {
  static override route = 'achievement';

  /**
   *
   */
  async getAchievements(publicId?: string) {
    try {
      const response = await this.httpService.get<
        BaseResponse<{ total: number; result: Achievement[] }>
      >(this.path, {
        params: publicId ? { [USER_PUBLIC_ID]: publicId } : undefined,
      });

      return response.data;
    } catch (e) {
      console.error(`Failed getting achievements`, e);
      throw e;
    }
  }

  /**
   *
   */
  async createShareableImage(
    achievementId: string,
    imageUrl: string,
  ): Promise<{ shareableUrl: string }> {
    try {
      const response = await this.httpService.post<
        { imageUrl: string },
        BaseResponse<{ shareableUrl: string }>
      >(`${this.path}/shareable-content/${achievementId}`, { imageUrl });

      return response.data;
    } catch (e) {
      console.error(`Failed creating shareable content: ${achievementId}`, e);
      throw e;
    }
  }

  /**
   *
   */
  async checkIfTotalPayoutImageExists(
    userId: string,
    amount: number,
  ): Promise<string | undefined> {
    const env = isProduction ? 'prod' : 'dev';
    const imageName = `/${getTotalPayoutImageTag(userId, amount)}.jpg`;
    const folder = `/${application}-${env}/${StorageContentType.Achievements}`;
    const url = cloudinaryImage(folder + imageName);

    return await this.httpService
      .get(url)
      .then(() => url)
      .catch(() => undefined);
  }
}
